import React, { useEffect, useState, useRef, useMemo } from "react";
import { useDispatch, useSelector } from 'react-redux';
import Pagination from "./../../components/pagination/Pagination.jsx";
import { DeviceRow } from "./DeviceRow";
import { fetchPaginatedDevices } from "../../actions/hardware_actions";
import { useNavigate } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";



import jsVectorMap from "jsvectormap";
import 'jsvectormap/dist/maps/world.js';
import 'jsvectormap/dist/jsvectormap.min.css';

import { Card, CardBody } from "./../../components/card/card.jsx";
import Chart from "react-apexcharts";

import Masonry from "masonry-layout";
import Select from "react-select";
// import {
//   ModeOptions,
//   DeviceOptions,
// } from "./../../components/selectvalues/selectvalue.jsx";

import { fetchHWSoldInfo, fetchHWActivatedInfo, fetchHWCraftedInfo, fetchHWActiveInfo } from "../../actions/hardware_actions.js";
import { fetchHardwareUsageStats } from "../../actions/dashboard_actions";

const Hardware = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const themeColor = getComputedStyle(document.body)
      .getPropertyValue("--bs-theme")
      .trim();
    
    const {
            hardware_chart_tile_info,
            // hardware_chart_tile_info_loading,
            // hardware_chart_tile_info_error,
            hardware_usage_expand_info: lineData,
            loading_hardware_usage_expand: lineLoading
          } = useSelector(state => state.dashboard);


    //Related to Paginated Table
    const itemsPerPage = 10; // fallback if Redux value missing

    const {
      paginated_devices,
      paginated_devices_total,
      paginated_devices_loading,
      paginated_devices_page,     // <-- Redux "current page"
      paginated_devices_perPage,  // <-- Redux items per page
    } = useSelector(state => state.hardware);

    const currentPage = paginated_devices_page || 1;
    const perPage = paginated_devices_perPage || itemsPerPage;

    // Pagination math
    const totalDevices = paginated_devices_total || 0;
    const startIndex = (currentPage - 1) * perPage + 1;
    const endIndex = Math.min(currentPage * perPage, totalDevices);
    const paginatedDeviceList = paginated_devices || [];

    // Handler for view button
    const handleView = (device) => {
      navigate(`/hardware-profile/${encodeURIComponent(device.device_name)}`);
    };

    // On pagination click (goes to new page)
    const handlePageChange = (page) => {
      dispatch(fetchPaginatedDevices(page, perPage));
    };



// Fetch data on mount AND when Redux page/perPage changes
useEffect(() => {
  dispatch(fetchPaginatedDevices(currentPage, perPage));
}, [dispatch, currentPage, perPage]);

useEffect(() => {
  // after mount, read the theme CSS var and rebuild your options
  setChartOptions(getChartOptions());
}, []); // or [themeColor] if you ever change that at runtime



    //////////////////////////////////
    const [activeButton, setActiveButton] = useState("3m"); // Default active button

    const { hw_sold_info, loading_hw_sold,
            hw_activated_info, loading_hw_activated,
            hw_active_info, loading_hw_active,
            hw_crafted_info, loading_hw_crafted
     } = useSelector((state) => state.hardware);
    
    useEffect(() => {
        // F-26: local state setters removed — series are now derived directly
        // from Redux state below to eliminate the one-render gap where
        // loading_hw_sold = false but totaldeviceData = [] (stale local state).

      }, [hw_sold_info, hw_activated_info, hw_crafted_info, hw_active_info]);


  const [countryData, setCountryData] = useState();
  const [serverChartOptions, setServerChartOptions] = useState(
    getServerChartOptions()
  );

  const [chartOptions, setChartOptions] = useState(getChartOptions());
  const [sourceChartData, setSourceChartData] = useState();
  const [hardrecipesData, sethardrecipesData] = useState();


  // F-26: derive series directly from Redux hw_*_info so there is no
  // intermediate render where loading = false but local state = [].
  // F-27: totalEver computed from hw_sold_info (already fetched) so the
  // "Total Ever" header no longer depends on hardware_chart_tile_info which
  // is never dispatched by this page.
  // Series order MUST match deviceLabels below: Coaster, 360, ShakerPro.
  // (Previously [0, 360, coaster, 0] against labels [Coaster, Coaster 2.0,
  // Barsys 360, Barsys 2.0], which showed the 360 count as "Coaster 2.0" and the
  // Coaster count as "Barsys 360", and dropped ShakerPro entirely.)
  const byDeviceType = (info) =>
    info ? [info.coasterDataCount ?? 0, info.Data360Count ?? 0, info.shakerProDataCount ?? 0] : [];
  const totaldeviceData    = byDeviceType(hw_sold_info);
  const totalrecipeData    = byDeviceType(hw_crafted_info);
  const totalactiveData    = byDeviceType(hw_active_info);
  const totalactivatedData = byDeviceType(hw_activated_info);
  const totalEver = hw_sold_info
    ? (hw_sold_info.coasterDataCount ?? 0) + (hw_sold_info.Data360Count ?? 0) + (hw_sold_info.shakerProDataCount ?? 0)
    : 0; 


  const [sourceData, setSourceData] = useState();

  // const [tdCoaster, setTDCoaster] = useState();
  const [tdCoaster2, setTDCoaster2] = useState();
  const [tdBarsys360, setTDCoaster360] = useState();
  // const [tdBarsys2, setBarsys2] = useState();

  // const [tadCoaster, setTADCoaster] = useState();
  const [tadCoaster2, setTADCoaster2] = useState();
  const [tadBarsys360, setTADCoaster360] = useState();
  // const [tadBarsys2, setTADBarsys2] = useState();

  // const [tacdCoaster, setTACDCoaster] = useState();
  const [tacdCoaster2, setTACDCoaster2] = useState();
  const [tacdBarsys360, setTACDCoaster360] = useState();
  // const [tacdBarsys2, setTACDBarsys2] = useState();

  // const [recipeCoaster, setRecipeCoaster] = useState();
  const [recipeCoaster2, setrecipeCoaster2] = useState();
  const [recipeBarsys360, setrecipeCoaster360] = useState();
  // const [recipeBarsys2, setrecipeBarsys2] = useState();

  //  const deviceLabels = ["Coaster", "Coaster 2.0", "Barsys 360", "Barsys 2.0"];
   const deviceSeries = totaldeviceData; 
    // // Fetch data on mount
    // useEffect(() => {
       
    // }, [dispatch]);

  function renderMap() {
    var inverse = getComputedStyle(document.body)
      .getPropertyValue("--bs-inverse")
      .trim();
    var themeColor = getComputedStyle(document.body)
      .getPropertyValue("--bs-theme")
      .trim();
    const map = document.getElementById("world-map");
    const mapElm = document.querySelectorAll(".jvm-tooltip");

    if (map) {
      for (let i = 0; i < mapElm.length; i++) {
        mapElm[i].remove();
      }
      map.innerHTML = "";

      new jsVectorMap({
        selector: "#world-map",
        map: "world",
        zoomButtons: true,
        normalizeFunction: "polynomial",
        hoverOpacity: 0.5,
        hoverColor: false,
        zoomOnScroll: false,
        series: { regions: [{ normalizeFunction: "polynomial" }] },
        labels: { markers: { render: (marker) => marker.name } },
        focusOn: { x: 0.5, y: 0.5, scale: 1 },
        markerStyle: {
          initial: { fill: themeColor, stroke: "none", r: 5 },
          hover: { fill: themeColor },
        },
        regionStyle: {
          initial: {
            fill: inverse,
            fillOpacity: 0.35,
            stroke: "none",
            strokeWidth: 0.4,
            strokeOpacity: 1,
          },
          hover: { fill: themeColor, fillOpacity: 0.9 },
        },
        backgroundColor: "transparent",
      });
    }
  }


  function getServerChartOptions() {
    var borderColor = getComputedStyle(document.body)
      .getPropertyValue("--bs-border-color")
      .trim();
    var bodyColor = getComputedStyle(document.body)
      .getPropertyValue("--bs-body-color")
      .trim();
    var inverseRgb = getComputedStyle(document.body)
      .getPropertyValue("--bs-inverse-rgb")
      .trim();
    var themeColor = getComputedStyle(document.body)
      .getPropertyValue("--bs-theme")
      .trim();
    var themeFont = getComputedStyle(document.body)
      .getPropertyValue("--bs-body-font-family")
      .trim();

    return {
      chart: { toolbar: { show: false } },
      plotOptions: {
        bar: { horizontal: false, columnWidth: "55%", endingShape: "rounded" },
      },
      dataLabels: { enabled: false },
      grid: { show: true, borderColor: borderColor },
      stroke: { show: false },
      colors: ["rgba(" + inverseRgb + ", .15)", themeColor],
      legend: { fontFamily: themeFont, labels: { colors: bodyColor } },
      xaxis: {
        categories: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ],
        labels: { show: false },
        axisBorder: {
          show: true,
          color: borderColor,
          height: 1,
          width: "100%",
          offsetX: 0,
          offsetY: -1,
        },
        axisTicks: {
          show: true,
          borderType: "solid",
          color: borderColor,
          height: 6,
          offsetX: 0,
          offsetY: 0,
        },
      },
      yaxis: {
        labels: {
          style: {
            colors: bodyColor,
            fontSize: "12px",
            fontFamily: themeFont,
            fontWeight: 400,
            cssClass: "apexcharts-xaxis-label",
          },
        },
      },
      fill: { opacity: 0.65 },
      tooltip: {
        y: {
          formatter: function (val) {
            return "$ " + val + " thousands";
          },
        },
      },
    };
  }

  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  // function CustomDropdown() {

  //   const handleDateChange = (event) => {
  //     if (event.target.name === 'fromDate') {
  //       setFromDate(event.target.value);
  //     } else {
  //       setToDate(event.target.value);
  //     }
  //   };

  //   return (
  //     <div className="custom-dropdown">
  //       <input type="date" name="fromDate" value={fromDate} onChange={handleDateChange} />
  //       <span>to</span>
  //       <input type="date" name="toDate" value={toDate} onChange={handleDateChange} />
  //     </div>
  //   );
  // }

  useEffect(() => {
    fetch("/assets/data/dashboard/country.json")
      .then((res) => res.json())
      .then((result) => {
        setCountryData(result);
      });

    fetch("/assets/data/dashboard/source.json")
      .then((res) => res.json())
      .then((result) => {
        setSourceData(result);
      });
    fetch("/assets/data/dashboard/source-chart.json")
      .then((res) => res.json())
      .then((result) => {
        setSourceChartData(result);
      });

    fetch("/assets/data/dashboard/hardrecipes.json")
      .then((res) => res.json())
      .then((result) => {
        sethardrecipesData(result);
      });

    fetch("/assets/data/dashboard/tacd.json")
      .then((res) => res.json())
      .then((result) => {
        // settotalactivatedData(result);
      });

    fetch("/assets/data/dashboard/tad.json")
      .then((res) => res.json())
      .then((result) => {
        // settotalactiveData(result);
      });

    renderMap();
    new Masonry("[data-masonry]");
    document.addEventListener("theme-reload", () => {
      setServerChartOptions(getServerChartOptions());
      setChartOptions(getChartOptions());
      renderMap();
    });

    // eslint-disable-next-line
  }, []);

  const price = 2750;
  const discountPercentage = 50;
  const discountedPrice = price - (price * discountPercentage) / 100;


  // Timestamp function to get time in seconds (divide by 1000)
  const getTimestamp = (date) => Math.floor(date.getTime() / 1000);
  const getDateTimeString = (date) => date.toISOString();
  // Function to calculate start and end time based on selected period
  const getStartEndTime = (period) => {
    const currentDate = new Date();
    let startTime;
    let endTime = getDateTimeString(currentDate);
  
    switch (period) {
      case "Today":
        startTime = getDateTimeString(new Date(currentDate.setHours(0, 0, 0, 0)));
        break;
      case "Yesterday":
        // Reset the date
        const yesterday = new Date();
        yesterday.setDate(yesterday.getDate() - 1);
        startTime = getDateTimeString(new Date(yesterday.setHours(0, 0, 0, 0)));
        endTime = getDateTimeString(new Date(yesterday.setHours(23, 59, 59, 999)));
        break;
      case "7d":
        // Calculate date 7 days ago
        const sevenDaysAgo = new Date();
        sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 7);
        startTime = getDateTimeString(sevenDaysAgo);
        break;
      case "30d":
        const thirtyDaysAgo = new Date();
        thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - 30);
        startTime = getDateTimeString(thirtyDaysAgo);
        break;
      case "3m":
        const threeMonthsAgo = new Date();
        threeMonthsAgo.setMonth(threeMonthsAgo.getMonth() - 3);
        startTime = getDateTimeString(threeMonthsAgo);
        break;
      case "6m":
        const sixMonthsAgo = new Date();
        sixMonthsAgo.setMonth(sixMonthsAgo.getMonth() - 6);
        startTime = getDateTimeString(sixMonthsAgo);
        break;
      case "12m":
        const twelveMonthsAgo = new Date();
        twelveMonthsAgo.setMonth(twelveMonthsAgo.getMonth() - 12);
        startTime = getDateTimeString(twelveMonthsAgo);
        break;
      default:
        startTime = getDateTimeString(new Date(0));
    }
    console.log('Start End Time Changed:', startTime, endTime);
    return { startTime, endTime };
  };

  const [reloadChart, setReloadChart] = useState(0);

  const handlePeriodChange = (newPeriod) => {
    setActiveButton(newPeriod);
    const { startTime, endTime } = getStartEndTime(newPeriod);

    // donuts
    dispatch(fetchHWSoldInfo(     startTime,endTime,"3"));
    dispatch(fetchHWActivatedInfo(startTime,endTime,"3"));
    dispatch(fetchHWCraftedInfo(  startTime,endTime,"3"));
    dispatch(fetchHWActiveInfo(   startTime,endTime,"3"));

    // // line-chart
    // dispatch(fetchHardwareUsageStats(
    //   newPeriod,
    //   limit,
    //   hwDeviceFilter.value,
    //   newPeriod === "custom" ? hwCustomFrom.toISOString() : undefined,
    //   newPeriod === "custom" ? hwCustomTo.toISOString()   : undefined
    // ));

    // force a remount of the chart
    setReloadChart(c => c + 1);
  };

  
  useEffect(() => {
      // Fetch data for the default period (e.g., "Today") on component mount
      handlePeriodChange('3m');
  }, []);

  const hasChartData = (series) => {
    return Array.isArray(series) && series.some(val => Number(val) !== 0);
  };

  function getChartOptions() {
    return {
      donut: {
        colors: [
          'rgba(var(--bs-theme-rgb), .15)',
          'rgba(var(--bs-theme-rgb), .35)',
          'rgba(var(--bs-theme-rgb), .55)',
          'rgba(var(--bs-theme-rgb), .75)',
          'rgba(var(--bs-theme-rgb), .95)'
        ],
         // ✅ removes the white outlines / outer ring
        stroke: {
          show: false,
          width: 0,
          colors: ['transparent'],
        },

        // optional: prevents “highlight” outlines on hover/active
        states: {
          hover: { filter: { type: "none" } },
          active: { filter: { type: "none" } },
        },
      }
      // other chart types…
    };
  }

  // ── Hardware Deployed (apply-on-click) filters ─────────────────────────────
  const hwPeriodOptions = [
    { value: "day",   label: "Daily"   },
    { value: "week",  label: "Weekly"  },
    { value: "month", label: "Monthly" },
    { value: "year",  label: "Yearly"  },
    // { value: "custom", label: "Custom" },
  ];

  const hwDeviceOptions = [
    { value: "coaster", label: "Coaster" },
    { value: "360",     label: "Barsys 360" },
    { value: "shakerpro",   label: "Shaker Pro"},
    { value: "all",     label: "All Devices" },
  ];

  // Local (editable) filter values
  const [hwLocalPeriod, setHwLocalPeriod]       = useState(hwPeriodOptions[1]); // Weekly default
  const [hwLocalDevice, setHwLocalDevice]       = useState(hwDeviceOptions[3]); // All default
  const [hwLocalLimit,  setHwLocalLimit]        = useState(10);
  const [hwLocalFrom,   setHwLocalFrom]         = useState(new Date());
  const [hwLocalTo,     setHwLocalTo]           = useState(new Date());

  // Apply lifecycle & equality tracking
  const [isHwApplying, setIsHwApplying]         = useState(false);
  const pendingHwApplyRef                       = useRef(null);
  const lastAppliedRef                          = useRef(null);

  // Normalize & compare helpers
  const normalizeHw = (p, d, l, from, to) => ({
    period: p.value,
    device: d.value,
    limit:  Number(l),
    from:   p.value === "custom" ? new Date(from).toISOString() : null,
    to:     p.value === "custom" ? new Date(to).toISOString()   : null,
  });

  const sameHw = (a, b) => JSON.stringify(a) === JSON.stringify(b);

  // Initial fetch once (with defaults)
  useEffect(() => {
    const init = normalizeHw(hwLocalPeriod, hwLocalDevice, hwLocalLimit, hwLocalFrom, hwLocalTo);
    lastAppliedRef.current = init;
    if (init.period === "custom") {
      dispatch(fetchHardwareUsageStats(init.period, init.limit, init.device, init.from, init.to));
    } else {
      dispatch(fetchHardwareUsageStats(init.period, init.limit, init.device));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Click "Apply" → show spinner and (if changed) dispatch after paint
  const applyHwFilters = () => {
    const next = normalizeHw(hwLocalPeriod, hwLocalDevice, hwLocalLimit, hwLocalFrom, hwLocalTo);
    if (sameHw(next, lastAppliedRef.current)) {
      // Nothing changed → do not show spinner or dispatch
      return;
    }
    pendingHwApplyRef.current = next;
    setIsHwApplying(true);
  };

  // Perform dispatch once spinner is visible
  useEffect(() => {
    if (!isHwApplying || !pendingHwApplyRef.current) return;
    const n = pendingHwApplyRef.current;
    lastAppliedRef.current = n; // record immediately to block duplicates

    if (n.period === "custom") {
      dispatch(fetchHardwareUsageStats(n.period, n.limit, n.device, n.from, n.to));
    } else {
      dispatch(fetchHardwareUsageStats(n.period, n.limit, n.device));
    }
    // fetching state is reflected by `lineLoading` from Redux
  }, [isHwApplying, dispatch]);

  // Clear applying once the real load finishes
  const prevLineLoadingRef = useRef(lineLoading);
  useEffect(() => {
    if (prevLineLoadingRef.current && !lineLoading) {
      setIsHwApplying(false);
      pendingHwApplyRef.current = null;
    }
    prevLineLoadingRef.current = lineLoading;
  }, [lineLoading]);

  // Chart data & options (memoized) to avoid wiggle
  const hwLabels = useMemo(
    () => (Array.isArray(lineData) ? lineData.map((r) => r.label) : []),
    [lineData]
  );
  const hwValues = useMemo(
    () => (Array.isArray(lineData) ? lineData.map((r) => Number(r.value) || 0) : []),
    [lineData]
  );
  const hwChartOptions = useMemo(() => {
    const bodyColor =
      getComputedStyle(document.body).getPropertyValue("--bs-body-color").trim();

    const mutedColor =
      getComputedStyle(document.body).getPropertyValue("--bs-secondary-color").trim() ||
      bodyColor;

    const borderColor =
      getComputedStyle(document.body).getPropertyValue("--bs-border-color").trim();

    const isDark =
      document.documentElement.getAttribute("data-bs-theme") === "dark" ||
      document.body.classList.contains("theme-black");

    return {
      chart: {
        type: "line",
        toolbar: { show: false },
        // ✅ makes most Apex text follow theme color automatically
        foreColor: mutedColor,
      },

      colors: [themeColor],
      stroke: { curve: "smooth", width: 2 },

      grid: { borderColor },

      xaxis: {
        categories: hwLabels,
        labels: {
          rotate: -45,
          style: {
            fontSize: "10px",
            fontWeight: 400,
            colors: mutedColor, //  theme-aware (no white-on-white)
          },
        },
      },

      yaxis: {
        labels: {
          style: {
            colors: mutedColor,
            fontWeight: 400,
          },
        },
      },

      tooltip: {
        theme: isDark ? "dark" : "light", //  readable tooltip in both modes
      },
    };
  }, [hwLabels, themeColor]);

  const hideHwChart = isHwApplying || lineLoading;


  // Extract your donut palette from chartOptions:
  // const donutOpts    = chartOptions.donut;
  // const donutColors  = donutOpts.colors;      // [ "rgba(...,.15)", "rgba(...,.35)", … ]

  // Map your data into series variables for each panel:
  const activatedSeries  = totalactivatedData;   // TOTAL ACTIVATED DEVICES
  const activeSeries     = totalactiveData;      // TOTAL ACTIVE DEVICES
  const recipeSeries     = totalrecipeData;      // RECIPES

  // const isThemeBlack = document.body.classList.contains("theme-black");
  // const legendLabelColor = isThemeBlack ? "rgba(255,255,255,.80)" : "rgba(0,0,0,.70)";

  // console.log('IsThemeBlack?', isThemeBlack)




    // common labels
    const deviceLabels = ["Barsys Coaster", "Barsys 360", "Barsys ShakerPro"];

        const totalDevicesDonutOptions = {
          ...chartOptions.donut,
          labels: deviceLabels,
          legend: {
            show: true,
            position: 'right',          // keep it on the right
            horizontalAlign: 'center',  // center-align the column of labels
            // nudge it left (negative X) tight against the pie
            offsetX: 20,               
            // fine-tune vertical centering (0 = true center)
            offsetY: 50,                 
            itemMargin: { horizontal: 0, vertical: 2 },
            markers: { width: 8, height: 8, radius: 2 },
            fontSize: '12px',
            // labels: {
            //   colors: [legendLabelColor, legendLabelColor, legendLabelColor, legendLabelColor]  // theme-black readable
            // },
            cssClass: 'compact-active-legend'
          },
          dataLabels: { enabled: false },
          plotOptions: {
            pie: { donut: { labels: { show: false } } }
          },
          
          tooltip: {
            y: {
              title: { formatter: () => '' },
              formatter: (v, { seriesIndex }) => `${deviceLabels[seriesIndex]}: ${v}`
            }
          }
        };


      const totalActivatedDonutOptions = {
        ...chartOptions.donut,
        labels: deviceLabels,
        legend: {
          show: true,
          position: 'right',          // keep it on the right
          horizontalAlign: 'center',  // center-align the column of labels
          // nudge it left (negative X) tight against the pie
          offsetX: 20,               
          // fine-tune vertical centering (0 = true center)
          offsetY: 50,                 
          itemMargin: { horizontal: 0, vertical: 2 },
          markers: { width: 8, height: 8, radius: 2 },
          fontSize: '12px',
          // labels: {
          //   colors: ["rgba(255,255,255,.80)", "rgba(255,255,255,.80)", "rgba(255,255,255,.80)", "rgba(255,255,255,.80)"]  // theme-black readable
          // },
          cssClass: 'compact-active-legend'
        },
        dataLabels: { enabled: false },
        plotOptions: {
          pie: {
            donut: { labels: { show: false } }
          }
        },
        tooltip: {
          y: {
            title: { formatter: () => '' },
            formatter: (value, { seriesIndex }) =>
              `${deviceLabels[seriesIndex]}: ${value}`
          }
        }
      };

    const totalActiveDonutOptions = {
      ...chartOptions.donut,
      labels: deviceLabels,
      legend: {
        show: true,
        position: 'right',          // keep it on the right
        horizontalAlign: 'center',  // center-align the column of labels
        // nudge it left (negative X) tight against the pie
        offsetX: 20,               
        // fine-tune vertical centering (0 = true center)
        offsetY: 50,                 
        itemMargin: { horizontal: 0, vertical: 2 },
        markers: { width: 8, height: 8, radius: 2 },
        fontSize: '12px',
        // labels: {
        //     colors: ["rgba(255,255,255,.80)", "rgba(255,255,255,.80)", "rgba(255,255,255,.80)", "rgba(255,255,255,.80)"]  // theme-black readable
        // },
        cssClass: 'compact-active-legend'
      },   // turn off Apex’s built-in legend
      dataLabels: { enabled: false },
      plotOptions: {
        pie: { donut: { labels: { show: false } } }
      },
      tooltip: {
        y: {
          title:   { formatter: () => '' },
          formatter: (v, { seriesIndex }) =>
            `${deviceLabels[seriesIndex]}: ${v}`
        }
      }
    };

  // 1) Chart options for Total Crafted Recipes
  const totalRecipesDonutOptions = {
    ...chartOptions.donut,
    labels: deviceLabels,     // or recipeLabels if you have a separate array
  legend: {
    show: true,
    position: 'right',          // keep it on the right
    horizontalAlign: 'center',  // center-align the column of labels
    // nudge it left (negative X) tight against the pie
    offsetX: 20,               
    // fine-tune vertical centering (0 = true center)
    offsetY: 50,                 
    itemMargin: { horizontal: 0, vertical: 2 },
    markers: { width: 8, height: 8, radius: 2 },
    fontSize: '12px',
    // labels: {
    //   colors: [getComputedStyle(document.body).getPropertyValue("--bs-body-color").trim()]
    // },
    cssClass: 'compact-active-legend'
  },
    dataLabels: { enabled: false },
    plotOptions: {
      pie: { donut: { labels: { show: false } } }
    },
    tooltip: {
      y: {
        title:   { formatter: () => '' },
        formatter: (val, { seriesIndex }) =>
          `${deviceLabels[seriesIndex]}: ${val}`
      }
    }
  };



  return (
      <>
        <div className="row mb-3" data-masonry='{"percentPosition": true }'>
          <h3>Filter</h3>
          <div className="col-xl-12">
            {(() => {
              const isThemeBlack = document.body.classList.contains('theme-black');

              if (isThemeBlack) {
                // BLACK THEME — use the same control style we used elsewhere
                return (
                  <div className="d-flex flex-wrap justify-content-start align-items-center gap-2 theme-black-controls">
                    <button
                      className={`btn freq-btn${activeButton === 'Today' ? ' active is-active' : ''}`}
                      aria-pressed={activeButton === 'Today'}
                      onClick={() => handlePeriodChange('Today')}
                    >Today</button>

                    <button
                      className={`btn freq-btn${activeButton === 'Yesterday' ? ' active is-active' : ''}`}
                      aria-pressed={activeButton === 'Yesterday'}
                      onClick={() => handlePeriodChange('Yesterday')}
                    >Yesterday</button>

                    <button
                      className={`btn freq-btn${activeButton === '7d' ? ' active is-active' : ''}`}
                      aria-pressed={activeButton === '7d'}
                      onClick={() => handlePeriodChange('7d')}
                    >7 days</button>

                    <button
                      className={`btn freq-btn${activeButton === '30d' ? ' active is-active' : ''}`}
                      aria-pressed={activeButton === '30d'}
                      onClick={() => handlePeriodChange('30d')}
                    >30 days</button>

                    <button
                      className={`btn freq-btn${activeButton === '3m' ? ' active is-active' : ''}`}
                      aria-pressed={activeButton === '3m'}
                      onClick={() => handlePeriodChange('3m')}
                    >3 months</button>

                    <button
                      className={`btn freq-btn${activeButton === '6m' ? ' active is-active' : ''}`}
                      aria-pressed={activeButton === '6m'}
                      onClick={() => handlePeriodChange('6m')}
                    >6 months</button>

                    <button
                      className={`btn freq-btn${activeButton === '12m' ? ' active is-active' : ''}`}
                      aria-pressed={activeButton === '12m'}
                      onClick={() => handlePeriodChange('12m')}
                    >12 months</button>
                  </div>
                );
              }

              // NON-BLACK THEMES — leave your existing look
              return (
                <div className="d-flex flex-wrap gap-2">
                  <button className={`btn ${activeButton === 'Today' ? 'btn-theme' : 'btn-secondary'}`} onClick={() => handlePeriodChange('Today')}>Today</button>
                  <button className={`btn ${activeButton === 'Yesterday' ? 'btn-theme' : 'btn-secondary'}`} onClick={() => handlePeriodChange('Yesterday')}>Yesterday</button>
                  <button className={`btn ${activeButton === '7d' ? 'btn-theme' : 'btn-secondary'}`} onClick={() => handlePeriodChange('7d')}>7 days</button>
                  <button className={`btn ${activeButton === '30d' ? 'btn-theme' : 'btn-secondary'}`} onClick={() => handlePeriodChange('30d')}>30 days</button>
                  <button className={`btn ${activeButton === '3m' ? 'btn-theme' : 'btn-secondary'}`} onClick={() => handlePeriodChange('3m')}>3 months</button>
                  <button className={`btn ${activeButton === '6m' ? 'btn-theme' : 'btn-secondary'}`} onClick={() => handlePeriodChange('6m')}>6 months</button>
                  <button className={`btn ${activeButton === '12m' ? 'btn-theme' : 'btn-secondary'}`} onClick={() => handlePeriodChange('12m')}>12 months</button>
                </div>
              );
            })()}
          </div>
        </div>

        <div className="row" data-masonry='{"percentPosition": true }'>
        
        <div className="col-lg-6">
            <Card className="mb-3">
                <CardBody className="py-2">
                TOTAL DEVICES
                <div className="d-flex align-items-center">
                    <div className="w-60 mx-auto">
                        {loading_hw_sold ? (
                            <div
                              className="d-flex justify-content-center align-items-center"
                              style={{ height: "200px" }} // Ensures the spinner is 
                            >
                              <div
                                  className="spinner-border"
                                  role="status"
                                  style={{
                                  color: "var(--bs-theme)", // Theme-based spinner color
                                  width: "3rem",
                                  height: "3rem",
                                  }}
                              >
                                  <span className="visually-hidden">Loading hardware data...</span>
                              </div>
                            </div>
                        ) : hasChartData(deviceSeries) ? (
                          <div className="hardware-total-devices-chart">

                            <Chart
                              type="donut" height={200}
                              options={totalDevicesDonutOptions}
                              series={deviceSeries}
                              key={deviceSeries.join(",")}
                            />
                              <div className="custom-legend">
                                {deviceLabels.map((label, i) => (
                                  <div className="custom-legend-item" key={label}>
                                    <span className="custom-legend-label">{label}</span>
                                    <strong className="custom-legend-value">{deviceSeries[i]}</strong>
                                  </div>
                                ))}
                              </div>
                          </div>
                        ) : (
                            <div>No data available</div>
                        )}
                    </div>
                  </div>
                  </CardBody>
            </Card>
        </div>

        <div className="col-lg-6">
          <Card className="mb-3">
            <CardBody className="py-2">
              TOTAL ACTIVATED DEVICES
              <div className="d-flex align-items-center">
                <div className="w-60 mx-auto">
                  { loading_hw_activated ? (
                    <div
                      className="d-flex justify-content-center align-items-center"
                      style={{ height: "200px" }} // Ensures the spinner is 
                    >
                      <div
                          className="spinner-border"
                          role="status"
                          style={{
                          color: "var(--bs-theme)", // Theme-based spinner color
                          width: "3rem",
                          height: "3rem",
                          }}
                      >
                          <span className="visually-hidden">Loading hardware data...</span>
                      </div>
                    </div>
                  ) : hasChartData(activatedSeries) ? (
                    <div className="hardware-total-activated-devices-chart">
                      <Chart
                        type="donut"
                        height={200}
                        options={totalActivatedDonutOptions}
                        series={activatedSeries}
                        key={activatedSeries.join(',')}
                      />

                      <div className="custom-legend">
                        {deviceLabels.map((label, i) => (
                          <div className="custom-legend-item" key={label}>
                            {/* <span
                              className="custom-legend-marker"
                              style={{
                                backgroundColor:
                                  totalActivatedDonutOptions.colors?.[i] ?? '#888'
                              }}
                            /> */}
                            <span className="custom-legend-label">{label}</span>
                            <span className="custom-legend-value">
                              {activatedSeries[i]}
                            </span>
                          </div>
                        ))}
                      </div>
                    </div>
                  ) : (
                    <div>No data available</div>
                  )}
                </div>          
              </div>
            </CardBody>
          </Card>
        </div>

        <div className="col-lg-6">
          <Card className="mb-3">
            <CardBody className="py-2">
              TOTAL ACTIVE DEVICES
              <div className="d-flex align-items-center">
                <div className="w-60 mx-auto">
                  {loading_hw_active ? (
                    <div
                      className="d-flex justify-content-center align-items-center"
                      style={{ height: "200px" }} // Ensures the spinner is 
                    >
                      <div
                          className="spinner-border"
                          role="status"
                          style={{
                          color: "var(--bs-theme)", // Theme-based spinner color
                          width: "3rem",
                          height: "3rem",
                          }}
                      >
                          <span className="visually-hidden">Loading hardware data...</span>
                      </div>
                    </div>
                  ) : hasChartData(activeSeries) ? (
                    <div className="hardware-total-active-devices-chart">
                      <Chart
                        type="donut"
                        height={200}
                        options={totalActiveDonutOptions}
                        series={activeSeries}
                        key={activeSeries.join(',')}
                      />

                      <div className="custom-legend">
                        {deviceLabels.map((label, i) => (
                          <div className="custom-legend-item" key={label}>
                            {/* <span
                              className="custom-legend-marker"
                              style={{ backgroundColor: totalActiveDonutOptions.colors[i] }}
                            /> */}
                            <span className="custom-legend-label">{label}</span>
                            <span className="custom-legend-value">{activeSeries[i]}</span>
                          </div>
                        ))}
                      </div>
                    </div>
                  ) : (
                    <div>No data available</div>
                  )}
                </div>
              </div> 
            </CardBody>
          </Card>
        </div>
        
        <div className="col-lg-6">
          <Card className="mb-3">
            <CardBody className="py-2">
              TOTAL CRAFTED RECIPES
              <div className="d-flex align-items-center">
                <div className="w-60 mx-auto">
                  {loading_hw_crafted ? (
                    <div
                      className="d-flex justify-content-center align-items-center"
                      style={{ height: "200px" }} // Ensures the spinner is 
                    >
                      <div
                          className="spinner-border"
                          role="status"
                          style={{
                          color: "var(--bs-theme)", // Theme-based spinner color
                          width: "3rem",
                          height: "3rem",
                          }}
                      >
                          <span className="visually-hidden">Loading hardware data...</span>
                      </div>
                    </div>
                  ) : hasChartData(recipeSeries) ? (
                    <div className="hardware-total-recipes-chart">
                      <Chart
                        type="donut"
                        height={200}
                        options={totalRecipesDonutOptions}
                        series={recipeSeries}
                        key={recipeSeries.join(',')}
                      />

                      <div className="custom-legend">
                        {deviceLabels.map((label, i) => (
                          <div className="custom-legend-item" key={label}>
                            {/* omit the marker span entirely */}
                            <span className="custom-legend-label">{label}</span>
                            <span className="custom-legend-value">{recipeSeries[i]}</span>
                          </div>
                        ))}
                      </div>
                    </div>
                  ) : (
                    <div>No data available</div>
                  )}
                </div>
              </div>
            </CardBody>
          </Card>
          </div>
      </div>

      {/* ── Hardware Deployed Panel (apply-on-click) ── */}
      <div className="col-xl-12 mb-4">
        <Card>
          <CardBody>
            <h3>HARDWARE DEPLOYED</h3>
            <div style={{ marginBottom: 16, fontWeight: 500 }}>
              Total Ever: {totalEver.toLocaleString()} {/* F-27: computed from hw_sold_info, not hardware_chart_tile_info */}
            </div>

            {/* Filters row */}
            <div className="row mb-3 align-items-end">
              <div className="col-md-3">
                <label style={{ color: themeColor }}>Date Dimension</label>
                <Select
                  options={hwPeriodOptions}
                  value={hwLocalPeriod}
                  onChange={setHwLocalPeriod}
                  classNamePrefix="react-select"
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 3000 }),
                    menu:       (base) => ({ ...base, zIndex: 3000 }),
                  }}
                />
              </div>

              {hwLocalPeriod.value === "custom" && (
                <>
                  <div className="col-md-3">
                    <label style={{ color: themeColor }}>From</label>
                    <DatePicker
                      selected={hwLocalFrom}
                      onChange={setHwLocalFrom}
                      className="form-control"
                    />
                  </div>
                  <div className="col-md-3">
                    <label style={{ color: themeColor }}>To</label>
                    <DatePicker
                      selected={hwLocalTo}
                      onChange={setHwLocalTo}
                      className="form-control"
                    />
                  </div>
                </>
              )}

              <div className="col-md-3">
                <label style={{ color: themeColor }}>Device Filter</label>
                <Select
                  options={hwDeviceOptions}
                  value={hwLocalDevice}
                  onChange={setHwLocalDevice}
                  classNamePrefix="react-select"
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: (base) => ({ ...base, zIndex: 3000 }),
                    menu:       (base) => ({ ...base, zIndex: 3000 }),
                  }}
                />
              </div>

              <div className="col-md-2">
                <label style={{ color: themeColor }}>Limit</label>
                <input
                  type="number"
                  className="form-control"
                  value={hwLocalLimit}
                  min={1}
                  onChange={(e) => setHwLocalLimit(Number(e.target.value) || 1)}
                />
              </div>

              {/* Apply button separated (not stuck to inputs) */}
              <div className="col-auto">
                <label className="d-none d-md-block">&nbsp;</label>
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={applyHwFilters}
                  disabled={isHwApplying}
                  title="Apply filters"
                >
                  <i className="fas fa-search" />
                </button>
              </div>
            </div>

            {/* Chart with overlay spinner; keep chart mounted to avoid wiggle */}
            <div className="position-relative" style={{ minHeight: 350 }}>
              <div style={{ visibility: hideHwChart ? "hidden" : "visible" }}>
                {hwValues.length ? (
                  <Chart
                    options={hwChartOptions}
                    series={[{ name: "H/W Deployed", data: hwValues }]}
                    type="line"
                    height={350}
                  />
                ) : (
                  <div className="d-flex align-items-center justify-content-center" style={{ height: 350 }}>
                    No data
                  </div>
                )}
              </div>

              {hideHwChart && (
                <div className="position-absolute top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center">
                  <div className="spinner-border" style={{ color: themeColor }} />
                </div>
              )}
            </div>
          </CardBody>
        </Card>
      </div>
            

            <div className="col-xl-12">
              <Card className="mt-3">
                <span style={{ marginTop: "10px", left: "20px", fontSize: 14 }}>LAST CONNECTED DEVICES</span>
                <CardBody>
                  {/* Summary Info Aligned Right */}
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-end",
                      marginBottom: "10px",
                      fontSize: "14px",
                    }}
                  >
                    {paginated_devices_loading ? (
                      <small>Loading devices...</small>
                    ) : (
                  <small className="theme-summary-text">
                    Showing <span>{startIndex}</span> -{" "}
                    <span>{endIndex}</span> of{" "}
                    <span>{totalDevices}</span> devices
                  </small>

                    )}
                  </div>
                  <div
                    className="table-responsive"
                    style={{
                      minHeight: "300px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    {paginated_devices_loading  ? (
                      <div className="spinner-border" role="status" style={{ color: themeColor }}>
                        <span className="visually-hidden">Loading...</span>
                      </div>
                    ) : paginatedDeviceList.length === 0 ? (
                      <div>No Records Found</div>
                    ) : (
                      <table className="table table-bordered">
                        <tbody>
                          {paginatedDeviceList.map((device, idx) => (
                            <DeviceRow
                              key={device.device_name || idx}
                              device={device}
                              rank={startIndex + idx}
                              themeColor={themeColor}
                              onView={handleView}
                            />
                          ))}
                        </tbody>
                      </table>
                    )}
                  </div>
                </CardBody>
              </Card>
              <div className="row mt-3">
                <div className="col-md-10"></div>
                <div className="col-md-2">
                  <Pagination
                    currentPage={currentPage}
                    itemsPerPage={perPage}
                    totalItems={totalDevices}
                    paginate={handlePageChange}
                  />

                </div>
              </div>
            </div>
            <>
              <style>{`
                .theme-summary-text .summary-number {
                  color: var(--bs-theme);
                }
                body[data-bs-theme="dark"] .theme-summary-text .summary-number {
                  color: var(--bs-theme);
                }
              `}</style>
            </>
  </>
  );
};

export default Hardware;
